import imageCompression from 'browser-image-compression';
import { convertHeicToJpeg } from './heicUtils';
import { convertTiffToJpeg } from './tiffUtils';

export async function convertImage(file, fromFormat, toFormat) {

  if (fromFormat.toLowerCase() === 'heic' && toFormat.toLowerCase() === 'jpeg') {
    return await convertHeicToJpeg(file);
  }

  if (fromFormat.toLowerCase() === 'tiff' && toFormat.toLowerCase() === 'jpeg') {
    return await convertTiffToJpeg(file);
  }

  // Проверяем формат входного файла
  const actualFormat = file.type.split('/')[1].toLowerCase();
  if (actualFormat !== fromFormat.toLowerCase()) {
    throw new Error(`Expected ${fromFormat} file, but got ${actualFormat}`);
  }

  try {
    // Сначала сжимаем изображение
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });

    // Создаем canvas для конвертации
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Загружаем изображение
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = URL.createObjectURL(compressedFile);
    });

    // Устанавливаем размеры canvas
    canvas.width = img.width;
    canvas.height = img.height;

    // Рисуем изображение на canvas
    ctx.drawImage(img, 0, 0);

    // Конвертируем в нужный формат
    let mimeType;
    let quality = 0.8;

    switch (toFormat.toLowerCase()) {
      case 'jpeg':
      case 'jpg':
        mimeType = 'image/jpeg';
        break;
      case 'png':
        mimeType = 'image/png';
        break;
      case 'webp':
        mimeType = 'image/webp';
        break;
      default:
        throw new Error(`Unsupported format: ${toFormat}`);
    }

    // Получаем blob из canvas
    const blob = await new Promise(resolve => {
      canvas.toBlob(resolve, mimeType, quality);
    });

    // Создаем URL для скачивания
    const url = URL.createObjectURL(blob);

    // Генерируем имя файла
    const originalName = file.name.split('.')[0];
    const newName = `${originalName}.${toFormat.toLowerCase()}`;

    return {
      url,
      name: newName,
      size: blob.size
    };
  } catch (error) {
    console.error('Error converting image:', error);
    throw error;
  }
}
